import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  unifierCalculationTypesList: [],
  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: "id",
    direction: "desc",
  },
  selectedRow: {},
  openModalType: "",
};

const unifierCalculationTypesSlice = createSlice({
  name: "unifierCalculationTypes",
  initialState,
  reducers: {
    setUnifierCalculationTypesList: (state, action) => {
      state.unifierCalculationTypesList = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setOpenModalType: (state, action) => {
      state.openModalType = action.payload;
    },
  },
});

export const {
  setUnifierCalculationTypesList,
  setPage,
  setRowsPerPage,
  setSort,
  setSelectedRow,
  setOpenModalType,
} = unifierCalculationTypesSlice.actions;

export default unifierCalculationTypesSlice.reducer;
